import { urls } from 'Constants/Urls'
import { AddressParamsModel, SuggestShortNameModel, AddressSuggestResult } from 'Models'
import { axiosDS } from '@pp/axios'
import { GET_SHORTNAME, TypeRequest } from 'Modules'

const getAddress = async (params: AddressParamsModel, typeRequest: TypeRequest) => {
	const res = await axiosDS().get<AddressSuggestResult>(urls.dadata[typeRequest], { params })
	return res.data
}

const getShortName = async (inn: GET_SHORTNAME) => {
	const res = await axiosDS().get<SuggestShortNameModel[]>(urls.dadata.short_name, {
		params: { inn },
	})
	return res.data
}

export const dadataApi = {
	getAddress,
	getShortName,
}
